import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2edab46b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "topThree" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ImgItem = _resolveComponent("ImgItem")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_ImgItem, {
      type: 1,
      value: _ctx.data.cargoLoadNum
    }, null, 8, ["value"]),
    _createVNode(_component_ImgItem, {
      type: 2,
      value: _ctx.data.cargoUnloadNum
    }, null, 8, ["value"])
  ]))
}